module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Roman.63b7e7b.woff";